import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/site/SEO";

const steps = [
  { n: "01", t: "Apply For An Advance", c: "Tell us about your pending deal, expected commission, and how much you want advanced. Our multi-step application is designed to be smooth and quick." },
  { n: "02", t: "Get Reviewed", c: "Our team reviews your transaction details, broker information, and closing timeline. We keep the process transparent and communicate quickly." },
  { n: "03", t: "Get Your Money", c: "Once approved and verified with your broker or closing officer, your funds can be sent fast — often the same business day." },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-page">
      <SEO
        title="How It Works"
        description="Three simple steps to get advanced on your pending real estate commission — apply, get reviewed, get funded."
        path="/how-it-works"
      />
      <section className="gradient-champagne py-20 text-center">
        <span className="overline">The Process</span>
        <h1 className="font-serif-lux text-5xl sm:text-6xl mt-5 px-6">How Hannah Howard <em className="italic text-[#5A3B31]">Commission Advances</em> Work</h1>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {steps.map((s) => (
          <div key={s.n} className="lux-card p-10">
            <span className="font-serif-lux text-6xl text-[#CBA4A4]">{s.n}</span>
            <h3 className="font-serif-lux text-3xl mt-2">{s.t}</h3>
            <p className="text-[#5A3B31] mt-3 leading-relaxed">{s.c}</p>
          </div>
        ))}
      </section>

      <section className="text-center py-16">
        <Link to="/apply" className="btn-primary inline-flex" data-testid="how-cta">
          Start My Application <ArrowRight size={18} strokeWidth={1.5} />
        </Link>
      </section>
    </div>
  );
}
